import { lazy, useContext } from 'react';

import { InputContext } from 'src/contexts/input.context';
import { UseIcon } from 'src/components/UseIcon';
import { ifTrue } from 'src/tools/logic.tools';
import { showModal } from 'src/components/Modal';
import { Factory } from 'src/components/Factory';
import { P2 } from 'src/components/Typography';

const ResourceCompanyModal = lazy(() => import('src/parsers/showPage/ResourceCompanyModal'));

export function CompanyView() {
  const { data: company_id, value } = useContext(InputContext);

  function handleOnView() {
    if (!company_id) return;

    showModal({
      content: (
        <Factory>
          <ResourceCompanyModal companyId={company_id} />
        </Factory>
      ),
    });
  }

  function renderButton() {
    return (
      <>
        <P2 className='t-ellipsis' title={value}>
          {value}
        </P2>
        <UseIcon className='default-icon' iconId='visibility-on' wrapElement='button' onClick={handleOnView} />
      </>
    );
  }

  return <div className='row items-p8 a-center w-100p o-hidden'>{ifTrue(company_id, renderButton)}</div>;
}
